
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";
import LoadingSpinner from "@/components/itinerary/LoadingSpinner";

interface ItineraryLoadingProps {
  message?: string;
}

const ItineraryLoading: React.FC<ItineraryLoadingProps> = ({ message }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <LoadingSpinner />
      <div className="space-y-4 mt-8">
        <Skeleton className="h-8 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
          <div className="lg:col-span-1">
            <Skeleton className="h-[400px] w-full" />
          </div>
          <div className="lg:col-span-3">
            <Skeleton className="h-[500px] w-full" />
          </div>
        </div>
      </div>
      {message && (
        <div className="text-center mt-4 text-muted-foreground">
          {message}
        </div>
      )}
    </div>
  );
};

export default ItineraryLoading;
